import { css } from "@compiled/react";

import { Card } from "./components/card";
import { JiraIssue } from "./constants/types";
import { colors } from "./helpers";

interface ColumnProps {
    title: string;
    cards: JiraIssue[];
}
const columnStyle = css({
    backgroundColor: colors.elevationSurfaceSunken,
    borderRadius: "8px",
    flex: "1 1 0",
    paddingInlineStart: "5px",
    paddingInlineEnd: "5px",
    minHeight: "622px"
});
const columnTitleStyle = css({
    backgroundColor: colors.elevationSurfaceSunken,
    color: colors.textSubtle,
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    padding: "16px",
    textTransform: "uppercase",
    margin: "0px",
    lineHeight: "1.33333333"
});
const listStyle = css({
    display: "flex",
    flexDirection: "column-reverse"
});

export const Column = ({ title, cards }: ColumnProps) => {
    return (
        <div css={columnStyle}>
            <h3 css={columnTitleStyle}>{title}</h3>
            <div css={listStyle} role="list">
                {cards.map((card, i) => {
                    return (
                        card.id && (
                            <Card
                                key={i}
                                role="listitem"
                                priority={card.priority}
                                epicName={card.epicName}
                                assignee={card.assignee}
                                issueType={card.issueType}
                                summary={card.summary}
                                id={card.id}
                            />
                        )
                    );
                })}
            </div>
        </div>
    );
};
